/* eslint-disable */
import {useCallback, useState} from 'react';
import ScreenWrapper from '../../components/ScreenWrapper';
import ReceiptViewerModal, {
  getReceiptUrl,
} from '../../components/ReceiptViewerModal';
import {
  ActivityIndicator,
  Linking,
  Platform,
  Pressable,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  RefreshControl,
  FlatList,
} from 'react-native';
import {useFocusEffect} from '@react-navigation/native';
import {getFavouritesApi, removeStation} from '../../services/auth-service';
import Toast from 'react-native-toast-message';
import {useEffect} from 'react';
import {colors, card, radii, spacing, typography} from '../../config/theme';
import CashIcon from '../../assets/Cash.svg';
import CardIcon from '../../assets/Card.svg';
import ToiletIcon from '../../assets/Toilet.svg';
import ReceiptIcon from '../../assets/icons/recipt.svg';
import DirectionIcon from '../../assets/icons/direction.svg';
import BookmarkIcon from '../../assets/Bookmark.svg';
import {useTranslation} from 'react-i18next';

export const Favourites = ({navigation}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [rerender, setRerender] = useState(false);
  // Receipt (image or PDF) shown inside the app instead of a browser
  const [receiptViewerUrl, setReceiptViewerUrl] = useState(null);
  const {t} = useTranslation();

  const fetchFavourites = useCallback(async (isRefresh = false) => {
    try {
      if (isRefresh) {
        setRefreshing(true);
      } else {
        setLoading(true);
      }
      const response = await getFavouritesApi();
      if (response?.Success) {
        console.log('bookmark response', response?.Data?.bookmarks);
        setData(response?.Data?.bookmarks);
      }
    } catch (err) {
      Toast.show({
        type: 'error',
        text1: err.message || 'Failed to get favourites',
      });
    } finally {
      if (isRefresh) {
        setRefreshing(false);
      } else {
        setLoading(false);
      }
    }
  }, []);

  const removeBookmark= async (station)=>{
    try{
        const response = await removeStation(station);
        if (response.Success) {
          Toast.show({
            type: 'success',
            text1: response.Message,
          });
          setRerender(prev => !prev);
        } else {
          Toast.show({
            type: 'error',
            text1: response.Message,
          });
        }
    }catch(err){
        Toast.show({
            type: 'error',
            text1: t('root.Toast.Error.FailedToRemoveStation'),
          });
    }
  }

  useFocusEffect(
    useCallback(() => {
      fetchFavourites(false);
    }, [fetchFavourites, rerender]),
  );

  const getTimeAgo = timestamp => {
    if (!timestamp) return '';

    const now = new Date().getTime();
    const createdAt =
      typeof timestamp === 'string' ? parseInt(timestamp) : timestamp;
    const diffInMs = now - createdAt;
    const diffInSeconds = Math.floor(diffInMs / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);
    const diffInMonths = Math.floor(diffInDays / 30);
    const diffInYears = Math.floor(diffInDays / 365);

    if (diffInYears > 0) {
      return `${t('root.PumpSearch.UpdatedAgo.Updated')} ${diffInYears} ${
        diffInYears === 1
          ? t('root.PumpSearch.UpdatedAgo.Years')
          : t('root.PumpSearch.UpdatedAgo.YearsPlural')
      } ${t('root.PumpSearch.UpdatedAgo.Ago')}`;
    } else if (diffInMonths > 0) {
      return `${t('root.PumpSearch.UpdatedAgo.Updated')} ${diffInMonths} ${
        diffInMonths === 1
          ? t('root.PumpSearch.UpdatedAgo.Months')
          : t('root.PumpSearch.UpdatedAgo.MonthsPlural')
      } ${t('root.PumpSearch.UpdatedAgo.Ago')}`;
    } else if (diffInDays > 0) {
      return `${t('root.PumpSearch.UpdatedAgo.Updated')} ${diffInDays} ${
        diffInDays === 1
          ? t('root.PumpSearch.UpdatedAgo.Days')
          : t('root.PumpSearch.UpdatedAgo.DaysPlural')
      } ${t('root.PumpSearch.UpdatedAgo.Ago')}`;
    } else if (diffInHours > 0) {
      return `${t('root.PumpSearch.UpdatedAgo.Updated')} ${diffInHours} ${
        diffInHours === 1
          ? t('root.PumpSearch.UpdatedAgo.Hours')
          : t('root.PumpSearch.UpdatedAgo.HoursPlural')
      } ${t('root.PumpSearch.UpdatedAgo.Ago')}`;
    } else if (diffInMinutes > 0) {
      return `${t('root.PumpSearch.UpdatedAgo.Updated')} ${diffInMinutes} ${
        diffInMinutes === 1
          ? t('root.PumpSearch.UpdatedAgo.Minutes')
          : t('root.PumpSearch.UpdatedAgo.MinutesPlural')
      } ${t('root.PumpSearch.UpdatedAgo.Ago')}`;
    } else {
      return t('root.PumpSearch.UpdatedAgo.JustUpdated');
    }
  };

  const openDirections = useCallback(station => {
    const {lat, lng} = station.location;
    const label = encodeURIComponent(station.name);

    if (Platform.OS === 'ios') {
      // Try Apple Maps first, fallback to Google Maps
      const appleMapsUrl = `http://maps.apple.com/?daddr=${lat},${lng}&dirflg=d`;
      const googleMapsUrl = `comgooglemaps://?daddr=${lat},${lng}&directionsmode=driving`;
      const googleMapsWebUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;

      Linking.canOpenURL(googleMapsUrl)
        .then(supported => {
          if (supported) {
            Linking.openURL(googleMapsUrl);
          } else {
            Linking.openURL(appleMapsUrl);
          }
        })
        .catch(() => {
          Linking.openURL(googleMapsWebUrl);
        });
    } else {
      // Android - try Google Maps first, fallback to web
      const googleMapsUrl = `google.navigation:q=${lat},${lng}`;
      const googleMapsWebUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;

      Linking.canOpenURL(googleMapsUrl)
        .then(supported => {
          if (supported) {
            Linking.openURL(googleMapsUrl);
          } else {
            Linking.openURL(googleMapsWebUrl);
          }
        })
        .catch(() => {
          Linking.openURL(googleMapsWebUrl);
        });
    }
  }, []);

  const renderItem = ({item: station}) => {
    return (
      <View style={styles.stationContent}>
        <View style={styles.stationHeader}>
          <View style={styles.stationInfo}>
            <Text style={styles.stationName}>{station?.name}</Text>
          </View>
        </View>
        <Text style={styles.stationAddress}>{station?.address}</Text>
        <View style={styles.priceContainer}>
          {station?.latestPrice && (
            <View style={styles.priceInfo}>
              <Text style={styles.priceText}>
                €{station?.latestPrice || station?.estimatedPrice}/ltr
              </Text>
              {station?.createdAt && (
                <Text style={styles.priceTimeText}>
                  {getTimeAgo(station?.createdAt)}
                </Text>
              )}
            </View>
          )}
          <View style={styles.ratingContainer}>
            <Text style={styles.ratingText}>
              <Text style={styles.ratingStar}>★</Text> {station?.rating}
            </Text>
          </View>
        </View>

        {/* Action Buttons */}
        <View style={styles.stationActionButtons}>
          {!!getReceiptUrl(station?.recieptUrl) && (
            <Pressable
              style={({pressed}) => [
                styles.stationActionButton,
                pressed && styles.stationActionButtonPressed,
              ]}
              onPress={e => {
                e.stopPropagation();
                const receipt = getReceiptUrl(station?.recieptUrl);
                if (receipt) {
                  setReceiptViewerUrl(receipt);
                }
              }}>
              <ReceiptIcon width={14} height={14} fill={colors.primary} />
              <Text style={styles.stationActionButtonText}>
                {t('root.PumpSearch.ViewReceipt')}
              </Text>
            </Pressable>
          )}

          {station?.location?.lat && station?.location?.lng && (
            <Pressable
              style={({pressed}) => [
                styles.stationActionButton,
                pressed && styles.stationActionButtonPressed,
              ]}
              onPress={e => {
                e.stopPropagation();
                openDirections(station);
              }}>
              <DirectionIcon width={16} height={16} stroke={colors.primary} />
              <Text style={styles.stationActionButtonText}>
                {t('root.PumpSearch.Directions')}
              </Text>
            </Pressable>
          )}
          <Pressable
            style={({pressed}) => [
              styles.stationActionButton,
              styles.stationActionButtonActive,
              pressed && styles.stationActionButtonActivePressed,
            ]}
            onPress={() => {
                removeBookmark(station);
            }}>
            <BookmarkIcon
              width={16}
              height={16}
              stroke={colors.primary}
              fill={colors.primary}
            />
            <Text style={styles.stationActionButtonText}>
              {t('root.PumpSearch.Saved')}
            </Text>
          </Pressable>
        </View>
      </View>
    );
  };

  return (
    <ScreenWrapper
      isBackButton={true}
      onBack={() => navigation.goBack()}
      Heading="Favourites"
      refreshControl={
        <RefreshControl
          refreshing={refreshing}
          onRefresh={() => fetchFavourites(true)}
          colors={[colors.primary]}
          tintColor={colors.primary}
        />
      }>
      {loading ? (
        <ActivityIndicator
          size="large"
          color={colors.primary}
          style={styles.loader}
        />
      ) : data && data.length > 0 ? (
        <FlatList
          data={data}
          renderItem={renderItem}
          keyExtractor={item => item?.placeId}
          contentContainerStyle={styles.list}
        />
      ) : (
        <View style={styles.emptyState}>
          <View style={styles.emptyIconBackdrop}>
            <BookmarkIcon width={28} height={28} />
          </View>
          <Text style={styles.emptyText}>
            No favourites found
          </Text>
        </View>
      )}
      <ReceiptViewerModal
        url={receiptViewerUrl}
        onClose={() => setReceiptViewerUrl(null)}
      />
    </ScreenWrapper>
  );
};

const styles = StyleSheet.create({
  list: {
    paddingHorizontal: spacing.margin,
    paddingTop: spacing.sm,
    paddingBottom: spacing.xxl,
  },
  loader: {
    marginTop: spacing.xl,
  },
  stationContent: {
    ...card,
    padding: spacing.margin,
    marginBottom: spacing.md,
  },
  stationHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: spacing.xs,
  },
  stationInfo: {
    flex: 1,
  },
  stationName: {
    ...typography.headlineSm,
    color: colors.text,
  },
  stationAddress: {
    ...typography.bodyMd,
    color: colors.textMuted,
    marginBottom: spacing.md,
  },
  priceContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: spacing.sm,
  },
  priceInfo: {
    flex: 1,
  },
  priceText: {
    ...typography.headlineSm,
    color: colors.primary,
  },
  priceTimeText: {
    ...typography.bodySm,
    color: colors.textMuted,
    marginTop: 2,
  },
  ratingContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 28,
    paddingHorizontal: spacing.md,
    borderRadius: radii.pill,
    backgroundColor: colors.surfaceMuted,
  },
  ratingText: {
    ...typography.labelMd,
    color: colors.text,
  },
  ratingStar: {
    color: colors.warning,
  },
  stationActionButtons: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: spacing.md,
    gap: spacing.sm,
  },
  stationActionButton: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 36,
    paddingHorizontal: spacing.md,
    borderRadius: radii.pill,
    borderWidth: 1.5,
    borderColor: colors.border,
    backgroundColor: colors.surface,
    gap: 6,
  },
  stationActionButtonPressed: {
    backgroundColor: colors.surfaceMuted,
    transform: [{scale: 0.98}],
  },
  // "Saved" is the on-state of the bookmark toggle: soft mint fill.
  stationActionButtonActive: {
    borderColor: 'transparent',
    backgroundColor: colors.mintSoft,
  },
  stationActionButtonActivePressed: {
    backgroundColor: colors.primaryFixed,
    transform: [{scale: 0.98}],
  },
  stationActionButtonText: {
    ...typography.labelMd,
    color: colors.primary,
  },
  emptyState: {
    alignItems: 'center',
    paddingHorizontal: spacing.margin,
    marginTop: spacing.xxl,
    gap: spacing.md,
  },
  emptyIconBackdrop: {
    width: 64,
    height: 64,
    borderRadius: radii.pill,
    backgroundColor: colors.mintSoft,
    alignItems: 'center',
    justifyContent: 'center',
  },
  emptyText: {
    ...typography.bodyMd,
    color: colors.textMuted,
    textAlign: 'center',
  },
});